export default __webpack_public_path__ + "static/media/envelop.69de4a13.svg";